import React from "react";
import { default as MUIIconButton } from "@mui/material/IconButton";
import styled from "styled-components";

const StyledMUIIconButton = styled(MUIIconButton)`
  height: fit-content;

  button:focus {
    outline: none;
  }

  &.MuiIconButton-colorPrimary:not(.Mui-disabled) {
    color: var(--primaryColor) !important;
  }
`;

/**

Represents an icon button component.
@param {function} onClick - The function to be called when the button is clicked.
@param {React.ReactNode} icon - The icon element to be displayed within the button.
@param {string} ariaLabel - The ARIA label for the button.
@param {string} size - The size of the button.
@param {string} title - The title attribute for the button.
@param {boolean} disabled - Specifies whether the button is disabled.
@param {string} color - The color of the button. Default is "secondary".
@returns {JSX.Element} - The icon button component.
*/

export const IconButton = ({
  id,
  onClick,
  icon,
  ariaLabel,
  size,
  title,
  href,
  disabled,
  color = "secondary",
}) => {
  const getIcon = () => {
    return size ? React.cloneElement(icon, { fontSize: size }) : icon;
  };

  return (
    <StyledMUIIconButton
      id={id}
      color={color}
      aria-label={ariaLabel ?? title}
      onClick={onClick}
      disabled={disabled}
      size={size}
      href={href}
      title={title}
    >
      {getIcon()}
    </StyledMUIIconButton>
  );
};
